import $ from 'jquery';

import utils from './utils';
import menuMobile from './menu-mobile';
import search from './search';
import avviso from './avviso';
import slider from './slider';
import accordion from './accordion';
import initMap from './maps';
import categoryFilter from './category-filter';
import inputDate from './datepicker';
import select from './select';
import video from './video';
import risultati from './risultati-ricerca';

utils();
menuMobile();
search();
avviso();
slider();
accordion();
initMap();
categoryFilter();
inputDate();
select();
video();
risultati();


// WEBPACK FOOTER //
// ./src/assets/js/main.js